<template>
  <div class="wrap">
    <JNav :title="$t('促销代码')" />
    <div class="wrap_top">
      <div class="userinfo">
        <div class="avatar">
          <Avatar :src="userInfo.userimg" :defaultSrc="require('@/assets/Img/myImg/head.png')" size="65" />
        </div>
        <div class="userinfo_right">
          <div class="name">{{ userInfo.username }}</div>
          <div class="money">{{ $money(userInfo.money) }}</div>
        </div>
      </div>
    </div>
    <div class="cont">
      <div class="input_container">
        <Field v-model="input" :maxlength="9999999" clearable :placeholder="$t('填写您的优惠码')" />
        <div class="btn" :style="strReplace(input) ? { background: '#fd2f2f', color: 'var(--light)' } : {}" @click="redem">{{
          $t('兑换') }}</div>
      </div>
      <div class="order">
        <div class="order_title">{{ $t('促销代码列表') }}</div>
        <div class="order_list">
          <List @load="getList" v-model="loading" :finished="!hasMore" :finished-text="$t('Hint.notMore')"
            :loading-text="$t('Hint.loading')">
            <div class="list">
              <div class="list_item" v-for="item, index in lists" :key="index">
                <div class="form">
                  <div class="label">{{ $t('促销代码') }}</div>
                  <div class="value">{{ item.cdkey }}</div>
                </div>
                <div class="form">
                  <div class="label">{{ $t('label.amount') }}</div>
                  <div class="value">{{ item.money }}</div>
                </div>
                <div class="form">
                  <div class="label"></div>
                  <div class="value time">{{ $format(item.usedate) }}</div>
                </div>
              </div>
            </div>
          </List>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import JNav from "@/components/JNav"
import { Toast, Field, List } from "vant";
import { Avatar } from "@tt/components";
import { post } from "@/utils/newRequest";
import { MARKETING_CDKEY } from "@/api";
import RepeatClick from "@/utils/repeat";

const repeatClick = new RepeatClick();

export default {
  components: {
    JNav,
    Toast,
    Avatar,
    Field,
    List
  },
  data() {
    return {
      userInfo: {},
      input: '',
      page: 0,
      loading: false,
      hasMore: true,
      lists: [],
    }
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    strReplace(str) {
      return str.replace(/\s+/g, '')
    },
    async redem() {
      if (!this.strReplace(this.input)) return;
      let flag = repeatClick.getIsClick();
      if (flag) return;
      repeatClick.setIsClick(true);
      Toast.loading();
      try {
        const res = await MARKETING_CDKEY(this.input)
        Toast(res.msg);
        this.input = ''
        this.page = 0;
        let timer = setTimeout(() => {
          this.$nextTick(() => {
            this.getList();
          })
          this.getUserInfo()
          clearTimeout(timer)
        }, 1000)
      } catch (error) {
        Toast(error.msg)
      }
    },
    async getList() {
      this.page++;
      try {
        const { lists, hasMorePages } = await post("/marketing/cdkey", {
          pagesize: 5,
          page: this.page,
        });
        const realList = lists
        this.hasMore = hasMorePages;
        if (this.page == 1) {
          this.lists = realList
        } else {
          this.lists = [...this.lists, ...realList];
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.page--;
      }
    },
    getUserInfo() {
      Toast.loading();
      this.$api.getUserInfo((res) => {
        Toast.clear();
        this.userInfo = res;
      }, (err) => { Toast.clear(); });
    },
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background-color: #f5f5f9;

  .wrap_top {
    background: url('../../../assets/new/mine/promo-bg.jpg');
    background-size: cover;
    height: calc(160rem / 16);

    .userinfo {
      display: flex;
      padding: calc(12rem / 16) calc(25rem / 16);

      .avatar {
        border-radius: 50%;
        border: 5px solid #9fd2f9;
        display: flex;
        align-items: center;
        justify-content: center;

        /deep/ .van-image {
          display: block;
        }
      }

      .userinfo_right {
        margin-left: calc(15rem / 16);
        font-size: calc(13rem / 16);
        color: var(--light);
        font-weight: bold;

        .name {
          padding: calc(2.5rem / 16) 0;
        }

        .money {
          font-size: calc(21rem / 16);
          padding: calc(2.5rem / 16) 0;
        }
      }
    }
  }

  .cont {
    .input_container {
      padding: calc(10rem / 16) calc(12rem / 16) calc(15rem / 16);
      display: flex;
      align-items: center;

      /deep/ .van-cell {
        height: calc(45rem / 16);
        line-height: calc(45rem / 16);
        padding: 0 calc(15rem / 16);
        border-radius: calc(10rem / 16) 0 0 calc(10rem / 16);
      }

      .btn {
        height: calc(45rem / 16);
        line-height: calc(45rem / 16);
        padding: 0 calc(15rem / 16);
        background: #ddd;
        color: #999;
        border-radius: 0 calc(10rem / 16) calc(10rem / 16) 0;
        font-size: calc(12rem / 16);
      }
    }

    .order {
      .order_title {
        padding: 0 calc(12rem / 16);
        text-align: center;
        color: #656565;
        font-weight: 900;
        font-size: calc(16rem / 16);
      }

      .order_list {
        .list {
          padding: calc(12rem / 16);
          display: flex;
          flex-direction: column;
          gap: calc(12rem / 16);

          .list_item {
            background-color: var(--light);
            border-radius: calc(8rem / 16);
            padding: calc(12rem / 16);
            display: flex;
            flex-direction: column;
            gap: calc(5rem / 16);

            .form {
              display: flex;
              align-items: center;
              justify-content: space-between;
              font-size: calc(15rem / 16);
              color: #333;

              .time {
                color: #ccc;
                font-size: calc(14rem / 16);
              }
            }
          }
        }
      }
    }
  }
}
</style>